<template>
  <div class="form-field form-datex" :rel="name"
       v-bind:class="{'has-suffix': suffix,'form-required': requiredForm, 'form-disabled':isDisabled}">
    <div class="form-label">
      <label>{{ label }}</label>
    </div>
    <div class="form-input">
      <div class="form-input-wrapper">
        <i class="icon icon-icon_calendar"></i>
        <div class="date">
          <input type="text" v-model="internalInput" maxlength="10" :disabled="isDisabled" placeholder="jj.mm.aaaaa"/>
          <button class="bt-remove" @click="removeDate"><i class="icon icon-icon_close"></i></button>
        </div>
        <datepicker
            v-model="internalValueTmp"
            name="uniquename"
            format="yyyy-MM-dd"
            :clear-button="false"
            clear-button-icon="icon icon-icon_close"
            @selected="dateSelected"
            v-if="!isDisabled">
        </datepicker>
        <div class="datetime" v-if="!hideTimeVue">
          <input type="text" v-model="internalInputTime" :placeholder="timePlaceholder" maxlength="8"
                 :disabled="isDisabled"/>
          <button class="bt-remove" @click="removeTime"><i class="icon icon-icon_close"></i></button>
        </div>
        <span class="suffix" v-if="suffix"><span>{{ suffix }}</span></span>
      </div>
      <!--internalValue: {{ internalValue }}<br>internalInput: {{ internalInput }}<br>internalValueTmp: {{ internalValueTmp }}-->
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'FormField',
  props: ['value', 'label', 'name', 'placeholder', 'suffix', 'formatTime', 'time', 'required', 'locale', 'hideTime', 'disabled'],
  components: {Datepicker},
  data: function () {
    return {
      utcIsApplied: false,
      internalValue: null,
      internalValueTmp: null,
      internalInput: null,
      internalInputConverted: null,
      internalInputTime: null,
      dateTime: null,
      localeDate: null,
      hideTimeVue: null,
      sep: '-',
      inputFormat: 'DD-MM-YYYY',
      timePlaceholder: null,
      debounce: null
    }
  },
  created: function () {
    this.internalValue = this.value;
    this.dateTime = this.time;
    this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false
    this.localeDate = this.locale ? this.locale : 'UTC'
    this.hideTimeVue = this.hideTime ? this.hideTime : false
    this.timePlaceholder = this.time ? this.time : '00:00:00'
    this.setDisabled(this.disabled)
  },
  methods: {
    formatDate: function (date) {

      if (date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear(),
            hour = d.getHours(),
            minute = d.getMinutes(),
            second = d.getSeconds();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        if (hour.length < 2) hour = '0' + hour;
        if (minute.length < 2) minute = '0' + minute;
        if (second.length < 2) second = '0' + second;

        //console.log('formatDate return => ' + [year, month, day].join('-'))

        return [year, month, day].join('-')// + ' ' + [hour, minute, second].join(':');
      }

      return ''

    },
    removeTime: function () {
      this.internalInputTime = null;
      this.setFinalDateTime()
    },
    removeDate: function () {
      this.internalInput = null;
      this.internalInputConverted = null;
      this.internalValueTmp = null;
      this.setFinalDateTime()
    },
    dateSelected: function (dateString) {
      dateString = this.formatDate(dateString)
      this.internalInput = this.convertToLocalDate(dateString)
    },
    convertToLocalDate: function (dateString) {
      let f = '';
      dateString = dateString.replace(/[a-zA-Z]/g, "");
      dateString = dateString.replace(/[\W_]/g, this.sep);
      if (dateString.indexOf(this.sep) == 4) {
        f = 'YYYY-MM-DD';
      } else {
        f = this.inputFormat;
      }
      return moment(dateString, f).format(this.inputFormat);
    },
    convertToIsoDate: function (dateString) {
      let f = '';
      dateString = dateString.replace(/[a-zA-Z]/g, "");
      dateString = dateString.replace(/[\W_]/g, this.sep);
      if (dateString.indexOf(this.sep) == 4) {
        f = 'YYYY-MM-DD';
      } else {
        f = this.inputFormat;
      }
      return moment(dateString, f).format('YYYY-MM-DD');
    },
    modelUpdated: function (dateString) {

      let time = null
      if (dateString && dateString.length > 10) {
        // Time exists
        time = dateString.split(" ")[1]
      } else {
        time = this.timePlaceholder
      }

      this.internalInputTime = time

      if (dateString) {
        this.internalInput = this.convertToLocalDate(dateString)
      } else {
        this.internalInput = null
      }
    },
    updateUserFill: function (dateString) {
      let self = this;

      this.internalInputConverted = null;

      const regex = /[0-9]{1,2}[\.\-\/]{1}[0-9]{1,2}[\.\-\/]{1}[0-9]{4}/g;
      const regexUs = /[0-9]{4}[\.\-\/]{1}[0-9]{1,2}[\.\-\/]{1}[0-9]{1,2}/g;
      const found = dateString.match(regex);
      const foundUs = dateString.match(regexUs);

      if (dateString && (found || foundUs)) {
        clearInterval(this.debounce);
        this.debounce = setTimeout(function () {

          self.internalValueTmp = self.convertToIsoDate(dateString)
          self.internalInputConverted = self.convertToIsoDate(dateString)
          self.setFinalDateTime()

        }, 1000)
      }

      if( dateString == "" ){
        this.$emit('input', null);
      }

    },
    updateUserFillTime: function (dateString) {
      dateString = dateString.replace(/[a-zA-Z]/g, "");
      dateString = dateString.replace(/[\W_]/g, ':');
      this.internalInputTime = dateString;

      this.setFinalDateTime()
    },
    setFinalDateTime: function () {
      // Add time to date
      let time = this.internalInputTime ? this.internalInputTime : this.timePlaceholder
      if (this.internalInputConverted) {
        this.internalValue = this.internalInputConverted + " " + time
      } else {
        this.internalValue = null
      }

      this.$emit('input', this.internalValue);

    },
    setDisabled: function (value) {
      this.isDisabled = value && (value == 'true' || value == true) ? true : false
      this.$forceUpdate();
    }
  },
  watch: {
    'disabled'(newVal, oldVal) {
      this.setDisabled(newVal)
    },
    'value'(newVal, oldVal) {
      if (newVal != oldVal && newVal != this.internalInputConverted) {
        this.internalValue = newVal;
        this.modelUpdated(newVal)
      }
    },
    'internalValue'(newVal, oldVal) {
      if (newVal != oldVal && newVal != this.internalInputConverted) {
        this.internalValue = newVal;
        this.modelUpdated(newVal)
      }
    },
    'internalInput'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.updateUserFill(newVal)
      }
    },
    'internalInputTime'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.updateUserFillTime(newVal)
      }
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/form/DateX.vue